import { S } from './state.js';
// ---- Canvas / viewport ----
export const cv = /** @type {HTMLCanvasElement} */ (document.getElementById('game'));
export const ctx = /** @type {CanvasRenderingContext2D} */ (cv.getContext('2d'));
S.W = 0, S.H = 0, S.DPR = 1;

export function resize() {
  S.DPR = Math.min(window.devicePixelRatio || 1, 2);
  S.W = window.innerWidth; S.H = window.innerHeight;
  cv.width = S.W * S.DPR; cv.height = S.H * S.DPR;
  cv.style.width = S.W + 'px'; cv.style.height = S.H + 'px';
  ctx.setTransform(S.DPR, 0, 0, S.DPR, 0, 0);
}
window.addEventListener('resize', resize);
resize();
